import { Pipe, PipeTransform } from '@angular/core';
import { VideoDto } from '../../../models/trofaco/videoDto';
import { SafeUrl } from '@angular/platform-browser';

@Pipe({
    name: 'videoThumbnail'
})
export class VideoThumbnailPipe implements PipeTransform {

    transform(video: VideoDto): string | SafeUrl {
        let code = undefined;
        if (video.videoUrl.startsWith('https://www.youtube.com/watch?v='))
            code = video.videoUrl.replace('https://www.youtube.com/watch?v=', '');
        else if(video.videoUrl.startsWith('https://youtu.be/'))
            code = video.videoUrl.replace('https://youtu.be/', '');
        else
            return undefined
        return 'http://img.youtube.com/vi/' + code + '/hqdefault.jpg';
    }

}
